/** Floating tooltip for interactive charts. */
export default function ChartTooltip({ tip }) {
  if (!tip) return null;
  return (
    <div
      className="chart-tooltip"
      style={{
        left: tip.x,
        top: tip.y,
        transform: tip.placement === "above" ? "translate(-50%, -100%)" : "translate(-50%, 8px)",
      }}
    >
      {tip.title ? <div className="chart-tooltip-title">{tip.title}</div> : null}
      {(tip.lines || []).map((line) => (
        <div key={line} className="chart-tooltip-line">
          {line}
        </div>
      ))}
    </div>
  );
}
